import {iPlatformConfig} from "@customTypes/appDataTypes/PlatformConfigTypes";

import platformConfigInfo from "./platform-config.json";

const platformConfig = platformConfigInfo as iPlatformConfig;

export default platformConfig;
